import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-centre-small-opener',
  templateUrl: './centre-small-opener.component.html',
  styleUrls: ['./centre-small-opener.component.css']
})
export class CentreSmallOpenerComponent implements OnInit {

  @Input()dragCheck! : any

  constructor() { }

  ngOnInit(): void {
    if(this.dragCheck == undefined){
      this.dragCheck = false
    }
    else{
      document.getElementById('normal-header')?.classList.add('d-none')
    }
  }

}
